import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57eefc67"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "confirm-remove__dialog" }
const _hoisted_2 = { class: "confirm-remove__text" }
const _hoisted_3 = { class: "confirm-remove__footer" }

import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmRemoveNav',
  props: {
    text: null
  },
  emits: ["confirm", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'confirm'): void
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {





const { t } = useI18n()

const onOk = () => emit('confirm')
const onCancel = () => emit('close')

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.text), 1),
    _createElementVNode("footer", _hoisted_3, [
      _createVNode(_component_n_button, {
        class: "confirm-remove__btn",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('base.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_n_button, {
        class: "confirm-remove__btn",
        type: "error",
        onClick: onOk
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('components.navigator.navs.navRemove')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})